import React from 'react';
import PropTypes from 'prop-types';

import { getSrcString, getSrcSetString } from '../helpers/getSrcStrings';
import { SeoLink } from 'dibs-seo/exports/SeoLink';

import styles from './HpRespCollectionsModuleItemOld.scss';

function HpRespCollectionsModuleItemOld({ item, onClick }) {
    const { title, imageUrl, linkData } = item;
    return (
        <SeoLink
            linkData={linkData}
            className={styles.link}
            onClick={onClick}
            dataTn="collections-item-link"
        >
            <div className={styles.imageWrapper}>
                <img
                    className={styles.image}
                    src={getSrcString({ url: imageUrl })}
                    alt={title}
                    data-tn="collections-item-image"
                    srcSet={getSrcSetString({ url: imageUrl, widths: [120, 150] })}
                />
            </div>
            <span className={styles.title} data-tn="collections-item-title">
                {title}
            </span>
        </SeoLink>
    );
}

HpRespCollectionsModuleItemOld.propTypes = {
    item: PropTypes.shape({
        title: PropTypes.string,
        imageUrl: PropTypes.string,
        linkData: PropTypes.object.isRequired,
    }).isRequired,
    onClick: PropTypes.func,
};

HpRespCollectionsModuleItemOld.defaultProps = {
    onClick: () => {},
};

export { HpRespCollectionsModuleItemOld };
